import script from "./FrontPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FrontPage.vue?vue&type=script&setup=true&lang=js"

import "./FrontPage.vue?vue&type=style&index=0&id=33fc2131&lang=scss"

const __exports__ = script;

export default __exports__